import { render, staticRenderFns } from "./PxAvisoPlataformaFornecedor.vue?vue&type=template&id=2a10ae57"
import script from "./PxAvisoPlataformaFornecedor.vue?vue&type=script&lang=js"
export * from "./PxAvisoPlataformaFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports